import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import '/node_modules/flag-icons/css/flag-icons.min.css'
import './css/animations.scss'
import './css/styles.scss'
import i18n from './i18n'

createApp(App).use(i18n).use(router).use(store).mount('#app')
